// serviceWorkerRegistration.js
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (!('serviceWorker' in navigator)) return;

  const disableByEnv = process.env.REACT_APP_DISABLE_SERVICE_WORKER === 'true';
  const enableInDev = process.env.REACT_APP_ENABLE_SW_DEV === 'true';
  const allowInCurrentEnv = process.env.NODE_ENV === 'production' || enableInDev;

  // Prevent stale cache/CSS issues in development unless explicitly enabled.
  if (disableByEnv || !allowInCurrentEnv) {
    unregister();
    // If a stale SW is currently controlling the page, reload once after cleanup.
    if (navigator.serviceWorker.controller && !sessionStorage.getItem('sw_cleanup_reloaded')) {
      sessionStorage.setItem('sw_cleanup_reloaded', '1');
      setTimeout(() => window.location.reload(), 150);
    } else {
      sessionStorage.removeItem('sw_cleanup_reloaded');
    }
    console.log('Service Worker disabled for this environment.');
    return;
  }

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      // This is running on localhost. Let's check if a service worker still exists or not.
      checkValidServiceWorker(swUrl, config);

      // Add some additional logging to localhost, pointing developers to the
      // service worker/PWA documentation.
      navigator.serviceWorker.ready.then(() => {
        console.log(
          'This app is being served cache-first by a service worker. To learn more, visit https://cra.link/PWA'
        );
      });
    } else {
      // Is not localhost. Just register service worker
      registerValidSW(swUrl, config);
    }
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // Force an update check to reduce stale SW windows after deployments.
      registration.update().catch(() => {});
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // Tại thời điểm này, service worker đã được cập nhật
              console.log(
                'Nội dung mới có sẵn và sẽ được sử dụng khi tất cả ' +
                  'các tab cho trang này được đóng. Xem https://cra.link/PWA.'
              );

              // Thực thi callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            } else {
              // Tại thời điểm này, mọi thứ đã được cache trước
              console.log('Nội dung được cache để sử dụng ngoại tuyến.');

              // Thực thi callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
      
      // Đăng ký cho push notifications nếu được yêu cầu
      if (config && config.subscribeForPush) {
        subscribeToPushNotifications(registration);
      }
    })
    .catch((error) => {
      console.error('Lỗi trong quá trình đăng ký service worker:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Kiểm tra xem service worker có thể được tìm thấy hay không
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Đảm bảo service worker tồn tại và JS thực sự được trả về
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // Không tìm thấy service worker. Có thể là ứng dụng khác. Tải lại trang.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker được tìm thấy. Tiến hành như bình thường.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('Không có kết nối internet. Ứng dụng đang chạy ở chế độ ngoại tuyến.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
        if ('caches' in window) {
          caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key))));
        }
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Hàm đăng ký nhận push notifications
export async function subscribeToPushNotifications(registration) {
  try {
    // Chỉ đăng ký push khi người dùng đang có session
    if (!localStorage.getItem('user')) {
      console.log('Không có session đăng nhập. Bỏ qua đăng ký push notifications.');
      return null;
    }

    // Kiểm tra xem browser có hỗ trợ notifications không
    if (!('Notification' in window)) {
      console.log('Trình duyệt này không hỗ trợ thông báo.');
      return;
    }

    // Yêu cầu quyền thông báo nếu chưa được cấp
    if (Notification.permission !== 'granted') {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.log('Quyền thông báo không được cấp.');
        return;
      }
    }

    // Kiểm tra xem PushManager có được hỗ trợ không
    if (!('PushManager' in window)) {
      console.log('Trình duyệt này không hỗ trợ Push API.');
      return;
    }

    // Kiểm tra xem đã đăng ký chưa
    const existingSubscription = await registration.pushManager.getSubscription();
    if (existingSubscription) {
      console.log('Đã đăng ký nhận thông báo đẩy.');
      return existingSubscription;
    }

    // Lấy public key từ server với xử lý đặc biệt cho iOS
    let convertedVapidKey;
    try {
      // Xử lý đặc biệt cho iOS - sử dụng timeout ngắn hơn
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const timeoutDuration = isIOS ? 8000 : 15000; // 8s cho iOS, 15s cho các thiết bị khác

      console.log('Đang lấy VAPID key từ server...', { isIOS, timeoutDuration });

      // Thử nhiều cách để lấy VAPID key cho iOS
      let vapidResponse;
      let vapidError;

      // Cách 1: XMLHttpRequest cho iOS
      try {
        console.log('ðŸŽ VAPID: Thử cách 1 - XMLHttpRequest');

        const xhr = new XMLHttpRequest();
        const xhrPromise = new Promise((resolve, reject) => {
          xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
              if (xhr.status >= 200 && xhr.status < 300) {
                resolve({
                  ok: true,
                  status: xhr.status,
                  json: () => Promise.resolve(JSON.parse(xhr.responseText || '{}'))
                });
              } else {
                reject(new Error(`XHR VAPID failed: ${xhr.status}`));
              }
            }
          };

          xhr.onerror = () => reject(new Error('XHR VAPID network error'));
          xhr.ontimeout = () => reject(new Error('XHR VAPID timeout'));
        });

        xhr.open('GET', '/api/push-notifications/vapid-public-key', true);
        xhr.setRequestHeader('Accept', 'text/plain');
        xhr.timeout = 10000;
        xhr.send();

        vapidResponse = await xhrPromise;
        const vapidText = xhr.responseText;

        if (vapidText) {
          convertedVapidKey = urlBase64ToUint8Array(vapidText);
          console.log('âœ… VAPID Cách 1 (XHR) thành công');
        } else {
          throw new Error('Empty VAPID response');
        }
      } catch (error1) {
        console.log('âŒ VAPID Cách 1 thất bại:', error1.message);
        vapidError = error1;

        // Cách 2: Fetch đơn giản
        try {
          console.log('ðŸŽ VAPID: Thử cách 2 - fetch đơn giản');

          const response = await fetch('/api/notifications/vapid-key', {
            method: 'GET',
            headers: {
              'Accept': 'application/json'
            }
          });

          if (response.ok) {
            const responseText = await response.text();
            const responseData = safeParseJson(responseText);
            const vapidPublicKey = extractVapidPublicKey(responseData ?? responseText);

            if (vapidPublicKey) {
              convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey);
              console.log('âœ… VAPID Cách 2 thành công');
            } else {
              throw new Error('No VAPID key in response');
            }
          } else {
            throw new Error(`HTTP ${response.status}`);
          }
        } catch (error2) {
          console.log('âŒ VAPID Cách 2 thất bại:', error2.message);

          // Cách 3: Sử dụng key mặc định
          console.log('ðŸŽ VAPID: Sử dụng key mặc định');
          const defaultKey = DEFAULT_VAPID_PUBLIC_KEY;
          convertedVapidKey = urlBase64ToUint8Array(defaultKey);
          console.log('âš ï¸ Sử dụng VAPID key mặc định');
        }
      }
    } catch (error) {
      console.error('âŒ Error getting VAPID key:', error);

      // Xử lý lỗi đặc biệt cho iOS
      if (error.name === 'AbortError') {
        console.log('â° VAPID key request timeout - thử endpoint backup');
      } else if (error.message.includes('Failed to fetch') || error.message.includes('Network Error')) {
        console.log('ðŸŒ Network error - thử endpoint backup');
      }

      // Thử endpoint backup
      try {
        console.log(' Thử endpoint backup...');
        const backupResponse = await fetch('/api/push-notifications/vapid-public-key', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'text/plain'
          },
          cache: 'no-cache',
          credentials: 'same-origin'
        });

        if (backupResponse.ok) {
          const backupKey = await backupResponse.text();
          if (backupKey) {
            convertedVapidKey = urlBase64ToUint8Array(backupKey);
            console.log('âœ… Đã lấy VAPID key từ endpoint backup');
          } else {
            throw new Error('Backup endpoint returned empty key');
          }
        } else {
          throw new Error(`Backup endpoint failed: ${backupResponse.status}`);
        }
      } catch (backupError) {
        console.error('âŒ Backup endpoint cũng thất bại:', backupError);

        // Sử dụng một key mặc định để tránh lỗi
        const defaultKey = DEFAULT_VAPID_PUBLIC_KEY;
        convertedVapidKey = urlBase64ToUint8Array(defaultKey);
        console.log('âš ï¸ Sử dụng VAPID key mặc định');
      }
    }

    if (!(convertedVapidKey instanceof Uint8Array) || convertedVapidKey.length !== 65) {
      console.error('VAPID key không hợp lệ, bỏ qua đăng ký push notification.');
      return null;
    }

    // Đăng ký subscription
    let subscription;
    try {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: convertedVapidKey
      });
    } catch (error) {
      console.error('Error subscribing to push:', error);
      // Nếu không thể đăng ký, trả về null
      return null;
    }

    console.log('Đã đăng ký nhận thông báo đẩy thành công:', subscription);

    // Gửi thông tin subscription đến server
    await sendSubscriptionToServer(subscription);
    
    return subscription;
  } catch (error) {
    console.error('Lỗi khi đăng ký nhận thông báo đẩy:', error);
    return null;
  }
}

// Gửi thông tin subscription đến server
async function sendSubscriptionToServer(subscription) {
  try {
    // Lấy token xác thực từ localStorage
    const token = localStorage.getItem('authToken');
    
    // Lấy thông tin user từ localStorage
    const userString = localStorage.getItem('user');
    if (!userString) {
      console.warn('Không tìm thấy thông tin user. Không thể đăng ký nhận thông báo.');
      return;
    }
    
    let user;
    try {
      user = JSON.parse(userString);
    } catch (error) {
      console.error('Lỗi khi parse thông tin user:', error);
      return;
    }
    
    // Lấy device info
    const deviceInfo = {
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      language: navigator.language,
      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    };
    
    console.log('Gửi subscription đến server với token:', token ? 'Có' : 'Không');
    console.log('User info:', user ? `ID: ${user.id || user._id}` : 'Không có');

    // Xử lý đặc biệt cho iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const timeoutDuration = isIOS ? 12000 : 30000; // 12s cho iOS, 30s cho các thiết bị khác

    console.log('Gửi subscription đến server...', { isIOS, timeoutDuration });

    // Xử lý đặc biệt cho iOS - thử nhiều cách khác nhau
    let response;
    let lastError;

    // Cách 1: Thử với XMLHttpRequest (tương thích tốt hơn với iOS)
    try {
      console.log('ðŸŽ iOS: Thử cách 1 - XMLHttpRequest');

      const xhr = new XMLHttpRequest();
      const subscribeData = JSON.stringify({
        subscription: subscription,
        device: { ...deviceInfo, method: 'xhr' }
      });

      const xhrPromise = new Promise((resolve, reject) => {
        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) {
            if (xhr.status >= 200 && xhr.status < 300) {
              resolve({
                ok: true,
                status: xhr.status,
                json: () => Promise.resolve(JSON.parse(xhr.responseText || '{}'))
              });
            } else {
              reject(new Error(`XHR failed: ${xhr.status}`));
            }
          }
        };

        xhr.onerror = () => reject(new Error('XHR network error'));
        xhr.ontimeout = () => reject(new Error('XHR timeout'));
      });

      xhr.open('POST', '/api/push-notifications/subscribe', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      if (token) {
        xhr.setRequestHeader('x-auth-token', token);
      }
      xhr.timeout = 15000; // 15 giây timeout
      xhr.send(subscribeData);

      response = await xhrPromise;
      console.log('âœ… iOS Cách 1 (XHR) thành công:', response.status);
    } catch (error1) {
      console.log('âŒ iOS Cách 1 thất bại:', error1.message);
      lastError = error1;

      // Cách 2: Thử endpoint đơn giản với fetch
      try {
        console.log('ðŸŽ iOS: Thử cách 2 - fetch đơn giản');

        // Đợi 1 giây để iOS ổn định kết nối
        await new Promise(resolve => setTimeout(resolve, 1000));

        const simpleHeaders = {
          'Content-Type': 'application/json'
        };

        if (token) {
          simpleHeaders['x-auth-token'] = token;
        }

          response = await fetch('/api/push-notifications/subscribe', {
            method: 'POST',
            headers: simpleHeaders,
            body: JSON.stringify({
              subscription: subscription,
              device: { ...deviceInfo, method: 'simple' }
            }),
            credentials: 'include'
          });

        console.log('âœ… iOS Cách 2 thành công:', response.status);
      } catch (error2) {
        console.log('âŒ iOS Cách 2 thất bại:', error2.message);
        lastError = error2;

        // Cách 3: Thử gửi dữ liệu tối giản
        try {
          console.log('ðŸŽ iOS: Thử cách 3 - dữ liệu tối giản');

          const minimalData = {
            endpoint: subscription.endpoint,
            keys: {
              p256dh: subscription.getKey ? btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('p256dh')))) : '',
              auth: subscription.getKey ? btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('auth')))) : ''
            },
            device: { isIOS: true, method: 'minimal' }
          };

          response = await fetch('/api/push-notifications/subscribe', {
            method: 'POST',
            headers: (() => {
              const h = { 'Content-Type': 'application/json' };
              if (token) h['x-auth-token'] = token;
              return h;
            })(),
            body: JSON.stringify(minimalData),
            credentials: 'include'
          });

          console.log('âœ… iOS Cách 3 thành công:', response.status);
        } catch (error3) {
          console.error('âŒ iOS: Tất cả cách đều thất bại');
          console.error('Lỗi cuối cùng:', error3.message);
          throw new Error(`iOS Network Error: Không thể kết nối đến server. Vui lòng:\n1. Kiểm tra kết nối WiFi/4G\n2. Thử tắt/bật WiFi\n3. Khởi động lại Safari\n4. Thử lại sau vài phút`);
        }
      }
    }

    if (!response.ok) {
      const errorText = await response.text();
      console.error('HTTP error:', response.status, errorText);
      throw new Error(`Không thể gửi thông tin subscription đến server: ${response.status} ${errorText}`);
    }

    const data = await response.json();
    console.log('Đã gửi thông tin subscription đến server:', data);
  } catch (error) {
    console.error('Lỗi khi gửi thông tin subscription đến server:', error);

    // Xử lý lỗi đặc biệt cho iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (error.name === 'AbortError') {
      console.error('Request timeout khi gửi subscription đến server');
      if (isIOS) {
        console.log('Timeout trên iOS - có thể do kết nối mạng chậm');
      }
    } else if (error.message && error.message.includes('Network Error')) {
      console.error('Network error khi gửi subscription:', error.message);
      if (isIOS) {
        console.log('Network error trên iOS - có thể do hạn chế bảo mật');
      }
    } else if (error.message && error.message.includes('Failed to fetch')) {
      console.error('Failed to fetch khi gửi subscription:', error.message);
      if (isIOS) {
        console.log('Failed to fetch trên iOS - có thể do CORS hoặc SSL');
      }
    }

    if (error.message) console.error('Chi tiết lỗi:', error.message);
    if (error.stack) console.error('Stack trace:', error.stack);

    // Thử lại một lần nữa cho iOS nếu là lỗi network
    if (isIOS && (error.name === 'AbortError' || error.message?.includes('Network Error'))) {
      console.log('Thử lại gửi subscription cho iOS...');
      await retrySubscriptionForIOS(subscription, deviceInfo, token);
    }
  }
}

// Hàm retry đặc biệt cho iOS
async function retrySubscriptionForIOS(subscription, deviceInfo, token) {
  try {
    console.log('Retry gửi subscription cho iOS với timeout ngắn hơn...');

    // Đợi 3 giây trước khi thử lại để đảm bảo kết nối ổn định
    await new Promise(resolve => setTimeout(resolve, 3000));

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 8000); // 8 giây cho retry

    const response = await fetch('/api/push-notifications/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token,
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      },
      body: JSON.stringify({
        subscription: subscription,
        device: {
          ...deviceInfo,
          retryAttempt: true,
          retryTimestamp: new Date().toISOString()
        }
      }),
      signal: controller.signal,
      cache: 'no-cache',
      credentials: 'same-origin',
      // Thêm mode cho iOS
      mode: 'cors'
    });

    clearTimeout(timeoutId);

    if (response.ok) {
      const data = await response.json();
      console.log('âœ… Retry thành công - Đã gửi subscription đến server (iOS):', data);
      return true;
    } else {
      console.error('âŒ Retry thất bại - HTTP error:', response.status);
      return false;
    }
  } catch (retryError) {
    console.error('âŒ Retry thất bại cho iOS:', retryError);

    // Thử lại lần cuối với cấu hình đơn giản nhất
    try {
      console.log(' Thử lại lần cuối với cấu hình đơn giản...');
      await new Promise(resolve => setTimeout(resolve, 2000));

      const simpleResponse = await fetch('/api/push-notifications/subscribe', {
        method: 'POST',
        headers: (() => {
          const h = { 'Content-Type': 'application/json' };
          if (token) h['x-auth-token'] = token;
          return h;
        })(),
        body: JSON.stringify({
          subscription: subscription,
          device: {
            ...deviceInfo,
            finalRetry: true
          }
        }),
        credentials: 'include'
      });

      if (simpleResponse.ok) {
        console.log('âœ… Final retry thành công');
        return true;
      }
    } catch (finalError) {
      console.error('âŒ Final retry cũng thất bại:', finalError);
    }

    return false;
  }
}

// Chuyển đổi base64 string thành Uint8Array
// Cần thiết cho applicationServerKey
const DEFAULT_VAPID_PUBLIC_KEY = 'BEULBf61XEL9UUHOfD_egC3EPrsRBfFleQx2186mYCqBl-LMlQxrVuMu1A0gIagG0740JQ_9RAtQsuUq4eY2UP4';

function safeParseJson(value) {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  try {
    return JSON.parse(trimmed);
  } catch {
    return null;
  }
}

function extractVapidPublicKey(value) {
  if (value == null) {
    throw new Error('VAPID key bị thiếu.');
  }

  if (typeof value === 'object') {
    const fromObject = value.publicKey || value.vapidPublicKey || value.key;
    if (typeof fromObject === 'string') {
      return fromObject.trim();
    }
    throw new Error('Không tìm thấy public key trong response object.');
  }

  let raw = String(value).trim();
  if (!raw) {
    throw new Error('VAPID key rỗng.');
  }

  // Một số endpoint có thể trả JSON dạng string
  const parsed = safeParseJson(raw);
  if (parsed != null) {
    return extractVapidPublicKey(parsed);
  }

  // Loại bỏ ký tự xuống dòng/khoảng trắng và quote bao quanh
  raw = raw.replace(/\s+/g, '').replace(/^"+|"+$/g, '');
  return raw;
}

function urlBase64ToUint8Array(base64Input) {
  try {
    const vapidKey = extractVapidPublicKey(base64Input);

    if (!/^[A-Za-z0-9\-_]+$/.test(vapidKey)) {
      throw new Error('VAPID key chứa ký tự không hợp lệ cho base64url.');
    }

    const padding = '='.repeat((4 - (vapidKey.length % 4)) % 4);
    const base64 = (vapidKey + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let index = 0; index < rawData.length; index++) {
      outputArray[index] = rawData.charCodeAt(index);
    }

    // VAPID public key P-256 phải dài đúng 65 bytes
    if (outputArray.length !== 65) {
      throw new Error(`Độ dài VAPID key không hợp lệ: ${outputArray.length} bytes (expected 65).`);
    }

    return outputArray;
  } catch (error) {
    console.error('Error in urlBase64ToUint8Array:', error);
    throw error;
  }
}

